import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`:host{display:block}.nav-group,.sub-items{display:flex;flex-direction:column;gap:.25rem}.sub-items{padding:10px 8px}.sub-items.no-parent{padding-top:0}`;

export { css_248z as default };
